import React, { useEffect, useState } from "react";
import {
  SearchSelectors,
  UserContextSelectors
} from "../../../redux/selectors";
import { DataUtils } from "../../../utils";
import { EmptyComponent } from "../../common/EmptyComponent";
import Loadable from "react-loadable";
import { ClientProviderEnum } from "../../../constants";
import { useSelector } from "react-redux";
import { ClientProviderUtils } from "../../../utils/clientProviderUtils";

const getSearchMobile = clientProvider => {
  return Loadable({
    loader: () =>
      import(
        /* webpackChunkName: "search/[request]" */ `./${clientProvider}/SearchMobileMenuSection`
      ),

    loading: EmptyComponent
  });
};

const importSearchCss = clientProvider => {
  import(
    /* webpackChunkName: "search/[request]" */ `./${clientProvider}/css/${
      clientProvider === ClientProviderEnum.Kambi
        ? "search.scss"
        : `search-mobile-menu.scss`
    }`
  );
};

const SearchMenuSection = () => {
  const isMobile = useSelector(UserContextSelectors.isMobile);
  const searchSettings = useSelector(SearchSelectors.settings);
  const [isSearchEnabled, setIsSearchEnabled] = useState(false);
  const clientProvider = ClientProviderUtils.getClientProvider();

  useEffect(() => {
    const _isSearchEnabled =
      clientProvider === ClientProviderEnum.Spectate
        ? searchSettings.enabled
        : DataUtils.getDataStoreValue("SearchActive");

    setIsSearchEnabled(_isSearchEnabled);
  }, [clientProvider, searchSettings.enabled]);

  let SearchMenuSection;
  if (!isMobile || !isSearchEnabled) {
    SearchMenuSection = null;
  } else if (isSearchEnabled) {
    importSearchCss(clientProvider);
    SearchMenuSection = getSearchMobile(clientProvider);
  }

  return <>{SearchMenuSection && <SearchMenuSection />}</>;
};

export default React.memo(SearchMenuSection);
